import React from 'react';
import { formatProgressData, calculateChange } from '../lib/location-popup.utils';

interface LocationPopupTrendProps {
  dataProgress: number[];
}

export function LocationPopupTrend({ dataProgress }: LocationPopupTrendProps) {
  const progressData = React.useMemo(() => {
    return formatProgressData(dataProgress);
  }, [dataProgress]);

  if (progressData.length === 0) {
    return null;
  }

  const lastFourWeeks = progressData.slice(-4);

  return (
    <div className="mb-3">
      <h4 className="text-sm font-medium text-gray-700 mb-2">Historical Trend</h4>
      <div className="bg-gray-50 rounded p-2">
        <table className="w-full text-xs">
          <thead>
            <tr className="text-gray-600">
              <th className="text-left">Week</th>
              <th className="text-right">Stock (MT)</th>
              <th className="text-right">Change</th>
            </tr>
          </thead>
          <tbody>
            {lastFourWeeks.map((item, index) => {
              const prevValue = index > 0 ? lastFourWeeks[index - 1].value : 0;
              const change = calculateChange(item.value, prevValue);

              return (
                <tr key={item.week} className="border-t border-gray-200">
                  <td className="py-1">{item.week}</td>
                  <td className="text-right">{item.value.toLocaleString()}</td>
                  <td
                    className={`text-right ${
                      change.isPositive ? 'text-green-600' : change.isNegative ? 'text-red-600' : 'text-gray-500'
                    }`}>
                    {change.isPositive ? '+' : ''}
                    {change.value.toFixed(1)}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
